import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'common/libs/redux-persist/storage';

import userConfig from './busUserConfigReducer';
import controlSettings from './busControlSettingsReducer';
import thermalPrinter from './thermalPrinterReducer';

import autoCompleteStation from 'modules/bus/booking/search-form/reducers/busAutoCompleteStationReducer';
import autoCompleteAgent from 'modules/bus/booking/search-form/reducers/busAgentAutoCompleteReducer';
import bookingSearchForm from 'modules/bus/booking/search-form/reducers/BusBookingSearchFormReducer';
import bookingSearchResult from 'modules/bus/booking/search-result/reducers/busBookingSearchResultReducer';
import bookingFlow from 'modules/bus/booking/booking-flow/reducers/busBookingFlowReducer';
import transactionList from 'modules/bus/transaction-list/reducers/busTransactionList';
import goShowBookingForm from 'modules/bus/go-show/booking-form/reducers/busGoShowBookingFormReducer';
import busPaxManifestReducer from 'modules/bus/pax-manifest/search/reducers/busPaxManifestReducer';
import busPaxManifestDetailReducer from 'modules/bus/pax-manifest/detail/reducers/busPaxManifestDetailReducer';

import providerList from 'modules/bus/switch-provider/reducers/providerListReducer';

const userConfigPersistConfig = {
  key: 'busUserConfig',
  storage,
  throttle: 200,
  // 'initialized' should not be persisted to make sure userConfig
  // is fetched on each full page reload
  blacklist: ['initialized'],
};

export default combineReducers({
  userConfig: persistReducer(userConfigPersistConfig, userConfig),
  controlSettings,
  providerList,
  autoCompleteStation,
  autoCompleteAgent,
  bookingSearchForm,
  bookingSearchResult,
  bookingFlow,
  transactionList,
  goShowBookingForm,
  busPaxManifestReducer,
  busPaxManifestDetailReducer,
  thermalPrinter,
});
